module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Chat1_16"],"path":[{"$":{"d":"M11,6v5H8.36L7,12V11H2V6h9m2-2H0v9H5v2.83L9,13h4V4Zm3-3H3V3H14v7h2Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Chat1_16.svg
// module id = 0bB/
// module chunks = 1